var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "login-bg" }, [
      _vm.isLoading
        ? _c("div", { staticClass: "spinner text-center" }, [
            _c("img", {
              staticClass: "img-loading",
              attrs: { src: require("@/assets/images/spinner-loading.gif") },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "w-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "text-danger text-center" }, [
              _c("h4", [
                _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                _vm._v("\n          " + _vm._s(_vm.message) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "a",
                {
                  staticClass: "btn w-btn-secondary",
                  attrs: { href: "/login" },
                },
                [_vm._v(_vm._s(_vm.$t("misc.back_to")) + " Login")]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-logo-cnt" }, [
      _c("img", {
        staticClass: "login-logo",
        attrs: {
          alt: "Logo image",
          src: require("[envbyven]/assets/images/logo.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }